/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-editor.vue?vue&type=template&id=251bf911&scoped=true"
import script from "./pc-editor.vue?vue&type=script&lang=js"
export * from "./pc-editor.vue?vue&type=script&lang=js"
import style0 from "./pc-editor.vue?vue&type=style&index=0&id=251bf911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bf911",
  null
  
)

export default component.exports